const STORAGE_KEY = 'preminade_invite_token';

// Normalizes any user/URL input into the bare 6-char token: strips "PM-" prefix,
// whitespace, and uppercases. Keeps this logic in one place so the stored value,
// manual code entry, and the ?invite= URL param all agree on the same shape.
export function normalizeInviteToken(raw: string): string {
  return raw.trim().toUpperCase().replace(/^PM-?/, '').replace(/\s+/g, '');
}

export function storeInviteToken(raw: string): void {
  const token = normalizeInviteToken(raw);
  if (token) localStorage.setItem(STORAGE_KEY, token);
}

export function getStoredInviteToken(): string | null {
  return localStorage.getItem(STORAGE_KEY);
}

export function clearInviteToken(): void {
  localStorage.removeItem(STORAGE_KEY);
}
